import script from "./checkout.vue?vue&type=script&setup=true&lang=js"
export * from "./checkout.vue?vue&type=script&setup=true&lang=js"

import "./checkout.vue?vue&type=style&index=0&id=6c63a669&scoped=true&lang=less"

import exportComponent from "C:\\Users\\20303\\Desktop\\yesant\\code\\novapay\\syt\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c63a669"]])

export default __exports__